import React, { useEffect, useState } from "react";
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./PopupBanner.module.scss";
import CloseBtn from "../../images/close-Btn.svg";

const PopupBanner = () => {
  const [show, setShow] = useState(true);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const delayTimer = setTimeout(() => {
      setShow(true);
      setTimeout(() => setVisible(true), 50);
    }, 15000);

    return () => clearTimeout(delayTimer);
  }, []);

  if (!show) return null;
  const closePopup = () => {
    setVisible(false);
    setTimeout(() => setShow(false), 300);
  };

  return (
    <div
      className={`${styles.popupOverlay} ${visible ? styles.visible : ""}`}
      onClick={() => {
        setVisible(false);
        setTimeout(() => setShow(false), 300);
      }}
    >
      <div
        className={`${styles.popupContent} ${visible ? styles.visible : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <button className={styles.closeButton} onClick={closePopup}>
          <img src={CloseBtn} alt="close popup" />
        </button>
        <a
          href="https://datakulture.com/blog/datakulture-a-division-of-sedin-was-recognized-as-a-specialist-in-advanced-analytics-and-ai-services/"
          target="_blank"
        >
          <StaticImage
            src="../../images/Pop-ups-01.webp"
            alt="Datakulture Event Banner"
            placeholder="blurred"
            layout="constrained"
            className={styles.popupImage}
          />
        </a>
      </div>
    </div>
  );
};

export default PopupBanner;
